export default __webpack_public_path__ + "static/media/airplane.969b2a3d.png";